import { render, staticRenderFns } from "./CustomTextarea.vue?vue&type=template&id=6a505be8"
import script from "./CustomTextarea.vue?vue&type=script&lang=js"
export * from "./CustomTextarea.vue?vue&type=script&lang=js"
import style0 from "./CustomTextarea.vue?vue&type=style&index=0&id=6a505be8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports